import axios from "../../services/auth/jwt/config";
import { CURRENT_USER, INITIAL_CHATS, MOCK_MESSAGES, MOCK_USERS } from "./mock";
import { Chat, Message, User } from "./type";

export default {
    getChats: async (): Promise<Chat[]> => {
        const response = await axios.get<Chat[]>('ouvidoria/chat/list');
        return response.data;
    },
    getMessages: async (chatId: number, beforeId?: number, lastReadId?: number): Promise<Message[]> => {
        const response = await axios.get<Message[]>(`ouvidoria/chat/messages/${chatId}`, {
            params: {
                before_id: beforeId || undefined,
                last_read_id: lastReadId || undefined
            }
        });
        return response.data;
    },
    sendMessage: async (chatId: number, content: string, type: 'text' | 'file', file?: File): Promise<Message> => {
        const formData = new FormData();
        formData.append('content', content);
        formData.append('type', type);
        if (file) {
            formData.append('file', file);
        }
        const response = await axios.post<Message>(`ouvidoria/chat/send/${chatId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    },
    getAvailableUsers: async (): Promise<User[]> => {
        const response = await axios.get<User[]>('ouvidoria/chat/available-users');
        return response.data;
    },
    createChat: async (userId: number): Promise<Chat> => {
        const response = await axios.post<Chat>('ouvidoria/chat/create', { user_id: userId });
        return response.data;
    },
};